import React from 'react'

import { useDispatch } from 'react-redux'
import { Route } from 'react-router'

import { RecipeFeedback } from '@features/recipe-feedback'

import config from 'config/routes'
import { userRecipeRatings } from 'routes/Ratings/actions/feedback'

const RecipeFeedbackContainer = () => {
  const dispatch = useDispatch()

  return <RecipeFeedback loadUserRecipeRatings={() => dispatch(userRecipeRatings())} />
}

const route = <Route path={config.client.rateMyRecipes} component={RecipeFeedbackContainer} />

export { route }
